// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__nRQaZ","innerWrapper":"styles_innerWrapper__m_7FP","buttonsWrapper":"styles_buttonsWrapper__khda0"};